import React, { useState } from 'react';
import { Button, Form, Icon } from 'semantic-ui-react';
import { EyeIconClosed } from 'assets/icons/EyeIconClosed';
import { EyeIcon } from 'assets/icons/EyeIcon';
import PropTypes from 'prop-types';

export const MaskedInput = ({
  iconHeight = 24, eyePositionRight: eyeButtonOffsetRight = '20px', icon, type, submitRef, mask = 'disc', ...props }) => {
  const [maskedFieldType, setMaskedFieldType] = useState('masked');

  const handleToggleShowMasked = event => {
    event.preventDefault();
    setMaskedFieldType(prevState => (prevState === 'masked' ? 'text' : 'masked'));
    if (submitRef) submitRef?.current?.focus();
  };

  const button = (
    <Button
      onClick={handleToggleShowMasked}
      type="button"
      style={{
        backgroundColor: 'transparent',
        padding: '0',
        margin: '0',
        position: 'absolute',
        top: `calc(50% - (${iconHeight}px / 2))`,
        right: `${eyeButtonOffsetRight}`,
      }}
    >
      {maskedFieldType === 'masked' ? <EyeIconClosed /> : <EyeIcon />}
    </Button>
  );

  return (
    <Form.Input
      type={maskedFieldType}
      style={{
        '-webkit-text-security': maskedFieldType === 'masked' ? mask : 'none',
      }}
      {...props}
    >
      <input />
      {icon ? <Icon name={icon} /> : null}
      {button}
    </Form.Input>
  );
};

MaskedInput.propTypes = {
  submitRef: PropTypes.shape({
    current: PropTypes.instanceOf(Element),
  }).isRequired,
};
